export default {
  paymentInfo: '/v3/recruit/equipment/info',
  toPay: '/v3/recruit/registration/cost/pay'
}
